import React from 'react';

import cl from './About.module.css'

import Button from '../../../components/ui/BTN/Button';

import img_phone from '../../../assets/images/about_img_phone.png'
import phone_blur from '../../../assets/images/phone_blur.png'

import our_mission_target_img from '../../../assets/images/our_mission_target.jpg'
import our_mission_hands_img from '../../../assets/images/our_mission_hands_img.jpg'
import our_mission_regularity from '../../../assets/images/our_mission_regularity.jpg'
import Footer from '../../../components/Footer/Footer';
import { NavLink } from 'react-router-dom';
import {Helmet} from "react-helmet-async";







const About = () => {
    return (
        <div className='about_page'>
            <Helmet>
                <title>About Fortres BanCorp | Fintech Banking Innovation</title>
                <meta name="description" content="Learn about Fortres, a fintech platform providing innovative digital banking, global payments, and financial technology solutions." />
                <meta name="keywords" content="fintech banking platform, financial technology company, digital banking innovation" />
            </Helmet>
            <div className={cl.about_digital_banking_container}>
                <div className={cl.left_side_digital}>
                    <h1 className={cl.digital_title}>
                        Built to Redefine Digital Banking in Singapore
                    </h1>
                    <p className={cl.digital_descr}>
                        Founded with the vision to create a secure, transparent, and customer-first digital bank, Fortres BanCorp combines cutting-edge technology with Singapore’s rigorous regulatory standards. Our mission is to simplify banking for individuals and businesses alike, providing seamless financial services without unnecessary complexity.
                    </p>
                    <NavLink to='/sign-up'>
                    <Button />
                    </NavLink>
                </div>
                <div className={cl.right_side_digital}>
                    <img src={img_phone} alt="#img_phone" className={cl.img_phone} />
                    <img src={phone_blur} alt="#phone_blur" className={cl.blur_back_phone} />
                </div>
            </div>
            <div className={cl.our_mission_container}>
                <h2 className={cl.our_mission_title}>
                    About
                </h2>
                <h3 className={cl.our_mission_subtitle}>
                    Our Mission & Values
                </h3>
                <div className={cl.our_mission_row}>
                    <div className={cl.first_mission_item}>
                        <div className={cl.left_side_mission_item}>
                            <img src={our_mission_target_img} alt="#img_target" />
                        </div>
                        <div className={cl.right_side_mission_item}>
                            <h3 className={cl.mission_title}>
                                Our Mission
                            </h3>
                            <p className={cl.mission_subtitle}>
                                To empower every customer with easy, secure, and innovative banking solutions that fit their lifestyle and business needs.
                            </p>
                        </div>
                    </div>
                    <div className={cl.second_mission_item}>
                        
                        <div className={cl.right_side_mission_item}>
                            <h3 className={cl.mission_title}>
                                Our Core Values
                            </h3>
                            <p className={cl.mission_subtitle}>
                                Transparency: Clear fees, open communication, no hidden surprises.
                                <br/>
                                Security: Highest levels of data protection and regulatory compliance.
                                <br/>
                                Innovation: Continuous improvement through technology and customer feedback.
                                <br/>
                                Customer Centricity: Your needs guide every decision we make.
                            </p>
                        </div>
                         <div className={cl.left_side_mission_item}>
                            <img src={our_mission_hands_img} alt="#img_target" />
                        </div>
                    </div>
                     <div className={cl.first_mission_item}>
                        <div className={cl.left_side_mission_item}>
                            <img src={our_mission_regularity} alt="#img_target" />
                        </div>
                        <div className={cl.right_side_mission_item}>
                            <h3 className={cl.mission_title}>
                                Regulatory Commitment
                            </h3>
                            <p className={cl.mission_subtitle}>
                              As a licensed Major Payment Institution under the Monetary Authority of Singapore, we adhere strictly to MAS guidelines and the Personal Data Protection Act (PDPA), ensuring that your funds and personal information are always protected.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
           
        </div>
    );
};

export default About;